(function ($) {
    window.$ = jQuery;
    const SELECTOR_SLICK = '.video-slider__image-wrapper';
    const SELECTOR_VIDEO = '.video-slider video';

    const SETTINGS_SLICK = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: '0',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        arrows: true,
        draggable: false,
        centerMode: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };


    const initSlick = () => {

        if($(SELECTOR_VIDEO).length > 1) {
            const element = $(SELECTOR_SLICK);
            element.on('init', bindEvents);
            element.slick(SETTINGS_SLICK);
            element.on('beforeChange', function () {
                pauseAllVideos();
            });

            element.on('breakpoint', function () {
                bindEvents();
            });

        }
    };

    const pauseAllVideos = function () {
        $(SELECTOR_VIDEO).each(function () {
            if (!this.paused) {
                this.pause();
            }
            $(this).parent().removeClass('playing played');
            $(this).removeAttr('controls');
        });
    }

    const bindEvents = function () {
        $(SELECTOR_VIDEO).off('click');
        $(SELECTOR_VIDEO).on('click', function (e) {

            const slideNumber = $(this).parents('.slick-slide').data('slick-index');
            let video = this;

            if (slideNumber !== undefined && $(SELECTOR_SLICK).slick('slickCurrentSlide') !== slideNumber) {
                pauseAllVideos();
                $(SELECTOR_SLICK).slick('slickGoTo', slideNumber);

                // Prevent playing wrong video in cloned slide
                video = $(this).parents('.slick-list').find(`.slick-center:not(.slick-cloned)`).find('video')[0];
            }
            if (video.paused && !$(video).parent().hasClass(('playing'))) {
                setTimeout(function (){
                    video.play();
                }, 10)
                $(video).parent().addClass('playing played');
                $(video).attr('controls', true);
            }
        });
    }

    initSlick();

})(jQuery);